export default __webpack_public_path__ + "static/workforce-42024cfd88278fbdf4cf5c02be0b57d6.png";